"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// breakpoint lower limits
var BREAKPOINT_XXSMALL = 0;
var BREAKPOINT_XSMALL = 401;
var BREAKPOINT_SMALL = 541;
var BREAKPOINT_MEDIUM = 721;
var BREAKPOINT_LARGE = 901;
var BREAKPOINT_XLARGE = 1025;
var BREAKPOINT_XXLARGE = 1281;
var FONT_WEIGHTS = {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    black: 800
};
var theme = {
    breakpoints: {
        xxsmall: BREAKPOINT_XXSMALL,
        xsmall: BREAKPOINT_XSMALL,
        small: BREAKPOINT_SMALL,
        medium: BREAKPOINT_MEDIUM,
        large: BREAKPOINT_LARGE,
        xlarge: BREAKPOINT_XLARGE,
        xxlarge: BREAKPOINT_XXLARGE
    },
    sidebarWidth: '240px',
    sidebarV2Width: '401px',
    topbarHeight: '64px',
    color: {
        backgroundGrey: 'var(--color-mono-99)',
        completedStepBackgroundGrey: 'var(--color-mono-50)',
        disabledInputBackground: 'var(--color-mono-99)',
        disabledInputBorder: 'var(--color-mono-90)',
        facebook: '#3b5998',
        green: 'var(--color-green-30)',
        grey: 'var(--color-mono-50)',
        lightGreen: 'var(--color-green-50)',
        lightGrey: 'var(--color-mono-90)',
        lightRed: 'var(--color-red-60)',
        linkedin: '#0077b5',
        orcid: '#9cc732',
        primaryBrand: '#347e7a',
        primaryBrandHover: 'var(--color-teal-10)',
        primaryBrandLight: 'var(--color-teal-95)',
        primaryLink: 'var(--color-blue-40)',
        primaryLinkHover: 'var(--color-blue-20)',
        // TODO introduce purple again?
        purple: '#855daf',
        red: 'var(--color-red-50)',
        secondaryBrand: 'var(--color-mono-0)',
        sidebarGrey: 'var(--color-mono-99)',
        sidebarHover: 'var(--color-mono-95)',
        transparent: 'transparent',
        twitter: '#1da1f2',
        warning: 'var(--color-yellow-60)',
        white: 'var(--color-mono-100)',
        yellow: 'var(--color-yellow-80)',
        black: 'var(--color-mono-0)'
    },
    borderRadius: {
        small: '0.1875rem',
        regular: '0.5rem',
        large: '3rem'
    },
    textSizes: {
        h1_new: {
            fontSize: ['var(--fontSizes-xxxxl)', 'var(--fontSizes-xxxxl)'],
            lineHeight: ['var(--lineHeights-xxxxl)', 'var(--lineHeights-xxxxl)'],
            // not using var() because it's used as a key in font()
            font: 'Orleans',
            fontWeight: FONT_WEIGHTS.black
        },
        h2_new: {
            fontSize: ['var(--fontSizes-xxxl)', 'var(--fontSizes-xxxl)'],
            lineHeight: ['var(--lineHeights-xxxl)', 'var(--lineHeights-xxxl)'],
            font: 'Orleans',
            fontWeight: FONT_WEIGHTS.black
        },
        h3_new: {
            fontSize: ['var(--fontSizes-xl)', 'var(--fontSizes-xl)'],
            lineHeight: ['var(--lineHeights-xl)', 'var(--lineHeights-xl)'],
            font: 'Inter',
            fontWeight: FONT_WEIGHTS.semiBold
        },
        h4_new: {
            fontSize: ['var(--fontSizes-l)', 'var(--fontSizes-l)'],
            lineHeight: ['var(--lineHeights-l)', 'var(--lineHeights-l)'],
            font: 'Inter',
            fontWeight: FONT_WEIGHTS.regular
        },
        h5_new: {
            fontSize: ['var(--fontSizes-normal)', 'var(--fontSizes-normal)'],
            lineHeight: ['var(--lineHeights-normal)', 'var(--lineHeights-normal)'],
            font: 'Inter',
            fontWeight: FONT_WEIGHTS.regular
        },
        body1_new: {
            fontSize: ['var(--fontSizes-normal)', 'var(--fontSizes-normal)'],
            lineHeight: ['var(--lineHeights-normal)', 'var(--lineHeights-normal)'],
            font: 'Inter',
            fontWeight: FONT_WEIGHTS.regular
        },
        body2_new: {
            fontSize: ['var(--fontSizes-s)', 'var(--fontSizes-s)'],
            lineHeight: ['var(--lineHeights-s)', 'var(--lineHeights-s)'],
            font: 'Inter',
            fontWeight: FONT_WEIGHTS.regular
        },
        body3: {
            fontSize: ['var(--fontSizes-s)', 'var(--fontSizes-s)'],
            lineHeight: ['var(--lineHeights-s)', 'var(--lineHeights-s)'],
            font: 'Inter',
            fontWeight: FONT_WEIGHTS.regular
        },
        caption_new: {
            fontSize: ['var(--fontSizes-xs)', 'var(--fontSizes-xs)'],
            lineHeight: ['var(--lineHeights-xs)', 'var(--lineHeights-xs)'],
            font: 'Inter',
            fontWeight: FONT_WEIGHTS.regular
        }
    },
    fontWeights: FONT_WEIGHTS,
    palettes: {
        primary: {
            background: 'primaryBrand',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'primaryBrandHover',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        secondary: {
            background: 'white',
            font: 'secondaryBrand',
            disabledFont: 'grey',
            backgroundHover: 'white',
            border: 'lightGrey',
            borderHover: 'secondaryBrand',
            disabledBackground: 'white'
        },
        red: {
            background: 'white',
            font: 'red',
            disabledFont: 'red',
            backgroundHover: 'white',
            border: 'red',
            borderHover: 'red',
            disabledBackground: 'lightGrey'
        },
        twitter: {
            background: 'twitter',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'twitter',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        facebook: {
            background: 'facebook',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'facebook',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        linkedin: {
            background: 'linkedin',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'linkedin',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        orcid: {
            background: 'orcid',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'orcid',
            border: 'transparent',
            borderHover: 'transparent',
            disabledBackground: 'lightGrey'
        },
        danger: {
            background: 'red',
            font: 'white',
            disabledFont: 'white',
            backgroundHover: 'red',
            border: 'red',
            borderHover: 'red',
            disabledBackground: 'lightGrey'
        }
    },
    z: {
        toast: 4000,
        popperFlyout: 3001,
        cookieBanner: 2002,
        modal: 2001,
        flyout: 1040,
        topbar: 1003,
        footer: 1002,
        sidebar: 1001,
        sidebarOverlay: 1000,
        topbarOverlay: 900,
        contextNavPrev: 801,
        contextNavNext: 800,
        backToPageLink: 100
    }
};
exports.default = theme;
//# sourceMappingURL=index.new.js.map